"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecrementPermanentNumberEventHandlerActivator = exports.DecrementPermanentNumberEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class DecrementPermanentNumberEventHandlerArgs {
    constructor(actor, key) {
        this.actor = actor;
        this.key = key;
        this.__type = EventHandlerType_1.EventHandlerType.DecrementPermanentNumber;
        this.__typeName = "DecrementPermanentNumber";
    }
}
exports.DecrementPermanentNumberEventHandlerArgs = DecrementPermanentNumberEventHandlerArgs;
let DecrementPermanentNumberEventHandlerActivator = class DecrementPermanentNumberEventHandlerActivator {
    activate(sequence, container, handler) {
        const { actor, key } = handler.args;
        const value = container.readPermanent(actor, key, 0);
        container.setPermanent(actor, key, value - 1);
    }
};
DecrementPermanentNumberEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.DecrementPermanentNumber)
], DecrementPermanentNumberEventHandlerActivator);
exports.DecrementPermanentNumberEventHandlerActivator = DecrementPermanentNumberEventHandlerActivator;
